import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scrollt nach einer Navigation zu einem Anker (#id), z.B. wenn man von
 * /support auf /#faq klickt. React Router scrollt bei Hash-Links nicht von
 * selbst, und unter SSG fehlt das native Browser-Verhalten beim
 * Client-Routing. Ohne Hash bleibt das Verhalten unverändert (kein Scroll).
 */
export function ScrollToHash() {
  const { hash } = useLocation()

  useEffect(() => {
    if (!hash) return
    const id = decodeURIComponent(hash.slice(1))
    // Nach dem Render des Ziels scrollen (Layout + ggf. lazy Content).
    const timer = window.setTimeout(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }, 50)
    return () => window.clearTimeout(timer)
  }, [hash])

  return null
}
